import { persistReducer } from 'redux-persist'
import { Action } from '@reduxjs/toolkit'
import storage from 'redux-persist/lib/storage'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  GetRequestTableData: '[GetRequestTableData] Action',
  SetRequestTableData: '[SetRequestTableData] Action',
}

const initialPortalUserState: IPortalUserState = {
  columnList: [],
  columnValues: [],
  de: [],
  en: []
}

export interface IPortalUserState {
  columnValues: [],
  columnList: [],
  de: [],
  en: []
}

export const reducer = persistReducer(
  { storage, key: 'portal-requestTable', whitelist: [] },
  (state: IPortalUserState = initialPortalUserState, action: any) => {
    switch (action.type) {
      case actionTypes.GetRequestTableData: {
        const columnValues = action.payload.data.syncDevices;
        let headers = action.payload.data.headers;
        let columnList: any = [];
        headers.forEach((element: any) => {
          if (element)
            columnList.push(element)
        });

        return { ...state, columnList, columnValues };
      }

      case actionTypes.SetRequestTableData: {
        const columnValues = action.payload.data;
        let columnList: any = [];

        return { ...state, columnValues, columnList };
      }

      default:
        return state
    }
  }
)

export const actions = {
  getRequestTableData: (data: any) => ({ type: actionTypes.GetRequestTableData, payload: { data } }),
  setRequestTableData: (data: any) => ({ type: actionTypes.SetRequestTableData, payload: { data } }),
  store: () => ({ type: "def" }),
}

export function* saga() {

}
